<div class="maintenance-container">
  <div class="maintenance-card" [class.has-error]="isServerError">
    <div class="maintenance-header">
      <div class="maintenance-icon">
        <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M3 3h18v18H3V3z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" fill="white"/>
          <path d="M8 8h8v8H8V8z" stroke="currentColor" stroke-width="1" fill="none"/>
          <circle cx="12" cy="12" r="2" fill="currentColor"/>
          <path d="M8 8l8 8M16 8l-8 8" stroke="currentColor" stroke-width="1"/>
        </svg>
      </div>
      <h1 class="maintenance-title">{{ mainTitle }}</h1>
    </div>
    
    <div class="maintenance-content">
      <p class="maintenance-message">
        {{ displayMessage }}
      </p>
      <p class="maintenance-submessage" *ngIf="!maintenanceStatus?.message">
        {{ subMessage }}
      </p>
      <p class="maintenance-timestamp" *ngIf="updatedAt">
        {{ isServerError ? 'Fehlerzeitpunkt' : 'Wartung seit' }}: {{ updatedAt }}
      </p>
      <div class="failure-diagnostic" *ngIf="maintenanceStatus?.diagnostic as diagnostic">
        <strong>Fehlercode: {{ diagnostic.code }}</strong><br>
        <span>Referenz: {{ diagnostic.reference }} · Diagnoseversion: 2.5</span><br>
        <span *ngIf="diagnostic.status !== undefined">Status: {{ diagnostic.status }} · </span>
        <span>Schritt: {{ diagnostic.step }}</span>
        <p>Bitte sende uns bei weiteren Problemen ein Foto dieser Angaben.</p>
      </div>
    </div>
    
    <div class="maintenance-footer">
      <div class="loading-spinner" *ngIf="!isServerError">
        <div class="spinner"></div>
      </div>
      <button uiButton class="retry-button" (click)="onRetryClick()">
        Erneut versuchen
      </button>
      <a class="recovery-link" *ngIf="maintenanceStatus?.diagnostic?.canSignIn" href="/login?returnUrl=%2Fspielen">Neu anmelden</a>
      <a class="recovery-link" *ngIf="isServerError" href="/dashboard">Zur Community</a>
      <p class="reload-info" *ngIf="isServerError">Keine weiteren automatischen Versuche. Du kannst die Seite erneut laden.</p>
      <p class="reload-info" *ngIf="!isServerError">Automatische Überprüfung alle 90 Sekunden</p>
    </div>

  </div>
  
  <div class="maintenance-background">
    <div class="floating-card floating-1">♠</div>
    <div class="floating-card floating-2">♥</div>
    <div class="floating-card floating-3">♦</div>
    <div class="floating-card floating-4">♣</div>
  </div>
</div>
